"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var referencesCtrl = function($scope, $uibModalInstance, $q, $http, $timeout, referencesParams) {
  var ctrl = this;
  var init = function() {
    $scope.references = referencesParams.references;
    $scope.ctrl = ctrl;
    $timeout(function() {
      angular.element('.modal.in textarea').focus();
    });
  };
  ctrl.addReference = function() {
    $scope.references.push({text: $scope.newReference});
    $scope.newReference = null;
  };
  ctrl.deleteReference = function(index) {
    $scope.references.splice(index, 1);
  };
  init();
};
referencesCtrl.$inject = ['$scope', '$uibModalInstance', '$q', '$http', '$timeout', 'referencesParams'];
module.exports = referencesCtrl;
